// extracted by mini-css-extract-plugin
export default {"container":"IndentSelect_container__Eo8gi","indentSelectLabel":"IndentSelect_indentSelectLabel__9dO2t","indentSelect":"IndentSelect_indentSelect__v+x+m"};